import * as React from 'react';
import { PaymentIn } from 'cb-model';
import {
  PageTitle,
  PaginatorAndListSettings,
  Search,
  Section,
  useCacheQuery,
  useQueryOptionsFromSearchParams,
} from 'gossamer-front-end';

/**
 * PaymentIn Search Page
 *
 * Search and list inbound payment records (read-only)
 */
export const PaymentInSearch = (): React.JSX.Element => {
  const [queryOptions, setQueryOptions] = useQueryOptionsFromSearchParams(PaymentIn);
  const gCacheQueryItem = useCacheQuery(PaymentIn, queryOptions);

  return (
    <>
      <PageTitle verb="Search" entity={PaymentIn} />
      <Section>
        <PaginatorAndListSettings
          entity={PaymentIn}
          gCacheQuery={gCacheQueryItem}
          queryOptions={queryOptions}
          render={Search}
          setQueryOptions={setQueryOptions}
        />
      </Section>
    </>
  );
};
